/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chat': {
    width: 512,
    height: 512,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M18 15c0 4.96-4.04 9-9 9-2.21 0-4.22-.8-5.79-2.13l6.32-6.34a.75.75 0 00.22-.53V6.03c.25.02.5.05.75.09v.13a3.25 3.25 0 003 3.24v.76a2.234 2.234 0 002.25 2.25c.63 0 1.23-.27 1.65-.72.39 1 .6 2.09.6 3.22z"/><path pid="1" d="M8.25 6.04v8.65l-6.1 6.12A8.873 8.873 0 010 15c0-4.71 3.64-8.59 8.25-8.96zM22.25 0h-8.5C12.785 0 12 .785 12 1.75v4.5c0 .965.785 1.75 1.75 1.75H15v2.25a.75.75 0 001.303.507L18.83 8h3.42C23.215 8 24 7.215 24 6.25v-4.5C24 .785 23.215 0 22.25 0zM15.5 4.75a.75.75 0 110-1.5.75.75 0 010 1.5zm2.5 0a.75.75 0 110-1.5.75.75 0 010 1.5zm2.5 0a.75.75 0 110-1.5.75.75 0 010 1.5z"/>'
  }
})
